module.exports = __webpack_public_path__ + "media/bangkok/bangkok temple better-9992bee0.jpg";